/**
 * Load article/page data
 * @param {string} slug - Page slug (city slug or page slug)
 * @param {string} locale - Language code ('de' or 'en')
 * @param {string} type - Type of page: 'city' or 'page' (default: auto-detect)
 * @returns {Promise<Object|null>} Article data or null if not found
 */
export const loadArticle = async (slug, locale = 'de', type = null) => {
  // Auto-detect type: check if it's a city by trying cities first
  if (!type) {
    try {
      const cityArticle = await import(`../data/cities/${locale}/${slug}.json`)
      return cityArticle.default || cityArticle
    } catch (cityError) {
      // Not a city, try pages
      type = 'page'
    }
  }
  
  try {
    if (type === 'city') {
      // Load from cities directory
      const article = await import(`../data/cities/${locale}/${slug}.json`)
      return article.default || article
    } else {
      // Load from pages directory (segment/global hub pages)
      const article = await import(`../data/pages/${locale}/${slug}.json`)
      return article.default || article
    }
  } catch (error) {
    // Article not found
    console.log(`Article not found for ${slug} in ${locale} (type: ${type || 'auto'})`)
    return null
  }
}

